import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import { action } from 'satcheljs/lib/legacy';
export default action('updateIsEditing')(function updateIsEditing(
    recipient: ReadWriteRecipientViewState,
    isEditing: boolean
) {
    recipient.isEditing = isEditing;
});
